import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {PupilsColumns} from './PupilsColumns'
import StaticTablePagination from '../../../_ui/Table/StaticTablePaginated';
import { contingentSchoolModule, loadPupils } from '../ContingentSchoolDucks'
import useTableFilter from '../../../components/TableFilter/useTableFilter';

export default function PupilsPage() {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const data = useSelector(state => state[contingentSchoolModule].pupils);
  const loadingTable = useSelector(state => state[contingentSchoolModule].loadingTabel);
  const { nextPage } = useTableFilter(filter =>
    dispatch(loadPupils({filter, type: 'WORKING'}))
  );

  return (
    <div className='mt1'>
      <StaticTablePagination
        sortable={false}
        loading={loadingTable}
        columns={PupilsColumns({
          t,
          lang: i18n.language,
         })
        }
        totalElements={data.totalElements}
        data={data.content}
        urlOnClick={row => `/contingent/school/${row.original.id}`}
        onClickLoadMore={() => nextPage()}
      />
    </div>
  );
}

